// @TODO the regenerator-runtime should be handled by the FINN polyfills
import 'regenerator-runtime/runtime';

import createHeartComponent from '@finn-no/favorite-heart-component';
import React from 'react';
import ReactDOM from 'react-dom';
import RecommendationsWithFallback from '../../podlet-common/src/RecommendationsWithFallback';
import hasLegalBasis from '../../podlet-common/src/legalBasis';

function init() {
    const ele = document.getElementById('recommend-podlet-root');
    if (ele) {
        const initialState = JSON.parse(
            document.getElementById('data-podlet-ssr-data').textContent
        );

        const {
            loginId,
            product,
            deviceType,
            adId,
            title,
            rows,
            pages,
            position,
            imagesCdnUrl,
            baseUrl,
            resourceMountPath,
            type,
            favoritesListUrl,
            fallbackTitle,
            fallbackProduct,
            url,
            debug,
            christmasGiftList,
            headingLevel = 2,
            showOverflowMenu,
            showVerticalFilter,
            enableLargePosition,
            showKeywords,
            previewId,
            previewType,
            suppressTitle,
        } = initialState;

        const Heart = createHeartComponent({
            userId: loginId,
            baseUri: favoritesListUrl,
        });

        const isMobile = deviceType !== 'desktop';
        const props = {
            title,
            baseUrl,
            renderActions: ({ adId, itemType }) => (
                <Heart
                    itemId={adId}
                    itemType={itemType}
                    isMobile={isMobile}
                    variant="heart-on-image"
                    christmasGiftList={christmasGiftList}
                />
            ),
            imagesCdnUrl,
            product,
            rows,
            pages,
            position,
            type,
            adId,
            url,
            deviceType,
            debug,
            headingLevel,
            showOverflowMenu,
            showVerticalFilter,
            enableLargePosition,
            showKeywords,
            previewId,
            previewType,
            suppressTitle,
        };

        hasLegalBasis(url).then((legalBasis) => {
            ReactDOM.render(
                <RecommendationsWithFallback
                    {...props}
                    fallbackTitle={fallbackTitle}
                    fallbackProduct={fallbackProduct}
                    forceFallback={!!!legalBasis}
                    enableLargePosition={enableLargePosition}
                />,
                ele
            );
        });
    }
}

init();
